require('./loansMortgagesBannerHeader.scss');
//@vendor
const React = require('react');
const { formatText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const { useState, useEffect} = React;

//@commons
const OKModal = require('components/commons/OKModal/OKModal');
const { recordEasyLoanCBannerContinue, recordEasyLoanCBannerCancel, recordEasyLoanCBannerMoreInfoView } = require( '../../contracts/contractEasyLoanTypeC/analytics/contractEasyLoanTypeC.tracking' );
//@core
const { FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTag = require('components/commons/OKTag/OKTag');
//@utils
const { recordLinkV2 } = require('utilities/tagging');

const LoansMortgagesBannerHeader = ({ clientName, bannerKeys, history, status, customButton, setVisibleStep, analyticsTagView }) => {
    const [displayLeaveModal, setDisplayLeaveModal] = useState(false);
    const [isLoadingPrimary, setIsLoadingPrimary] = useState(false);

    const handleRedirect = () => {
        recordEasyLoanCBannerContinue()
        if (bannerKeys.step) {
            setVisibleStep({ visibleStep: bannerKeys.step });
        }
        customButton.handleAnalyticsTagOKButton && customButton.handleAnalyticsTagOKButton();
        history.push(status === 'APROBADO' ? '/myprofile/loans-mortgages/contract-easy-loan-typeC' : '/myprofile/loans-mortgages/contract-easy-loan');
    }

    const openModal = () => {
        recordEasyLoanCBannerCancel();
        setDisplayLeaveModal(true);
        customButton.handleAnalyticsTag && customButton.handleAnalyticsTag();
    }

    const onCancelRecord = () => {
        setIsLoadingPrimary(true);
        customButton.onAccept();
    }

    const handlePrimaryButtonClick = () => {
        onCancelRecord();
        setIsLoadingPrimary(false);
        setDisplayLeaveModal(false);
    }

    const handleSecondaryButtonClick = () => {
        setDisplayLeaveModal(false);
    }

    const handleCloseModal = () => {
        setDisplayLeaveModal(false);
    }

    useEffect(() => {
        analyticsTagView && recordLinkV2(analyticsTagView);
        recordEasyLoanCBannerMoreInfoView();
    }, [analyticsTagView]);

    return (
        <div>
            <div className="header_card_container__card">
                <div className="header_card_container__container">
                    <div className="image">
                        <img
                            alt={'icon'}
                            className="uploaded-document-row__preview-img"
                            src={bannerKeys.bannerImage}
                        />
                    </div>
                    <div className="body">
                        <OKTag type={bannerKeys.typeTag} content={formatText(bannerKeys.bannerTag)} />
                        <div className="body__header">
                            {bannerKeys.bannerInitTitle ? (
                                <React.Fragment>
                                    <FormattedText value={bannerKeys.bannerInitTitle} />
                                    {clientName}! {" "}
                                </React.Fragment>
                            ) :
                                <span className="clientName">{clientName}, </span>
                            }

                            <FormattedText value={bannerKeys.bannerTitle} />
                        </div>
                        <FormattedText value={bannerKeys.bannerDescription} />
                        {bannerKeys.bannerDescriptionEmail && <b><FormattedText value={bannerKeys.bannerDescriptionEmail} /></b>} {" "}
                        {bannerKeys.bannerSecondDescription && <FormattedText value={bannerKeys.bannerSecondDescription} />} {" "}
                        {bannerKeys.bannerDescriptionEnd && <b><FormattedText value={bannerKeys.bannerDescriptionEnd} /></b>}
                    </div>
                    <div className="actions">
                        {bannerKeys.bannerButtonPrimary && (
                            <OKButton
                                onClick={handleRedirect}
                                modifier={'primary'}
                            >
                                <FormattedText value={bannerKeys.bannerButtonPrimary} />
                            </OKButton>
                        )}
                        <OKButton
                            modifier="ghost-inverse"
                            onClick={openModal}
                        >
                            <FormattedText
                                className="linkBanner"
                                value={bannerKeys.bannerButtonSecondary} />
                        </OKButton>
                    </div>
                </div>
            </div>
            {displayLeaveModal && (
                <OKModal
                    description={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalMessage')}
                    descriptionAlignment="center"
                    footerType="action"
                    isOpen={true}
                    onPrimaryButtonClick={handlePrimaryButtonClick}
                    onSecondaryButtonClick={handleSecondaryButtonClick}
                    primaryButtonText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalQuit')}
                    primaryButtonLoading={isLoadingPrimary}
                    secondaryButtonText={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalContinueLater')}
                    shouldCloseOnOverlayClick={false}
                    title={formatText('contractEasyLoanAndMortgagesTypeC-leaveModalTitle')}
                    titleAlignment="center"
                    onCloseCallback={handleCloseModal}
                />
            )}
        </div>
    );
};

LoansMortgagesBannerHeader.propTypes = {
    clientName: PropTypes.string,
    bannerKeys: PropTypes.object,
    history: PropTypes.object,
    status: PropTypes.string,
    customButton: PropTypes.func,
    setVisibleStep: PropTypes.func,
    analyticsTagView: PropTypes.object,
};

module.exports = LoansMortgagesBannerHeader;